import { isMockMode, post, simulateDelay } from "../api";

export const updateOfferingUsers = (data, isDelete) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Offerings/UpdateUsers`, data, {
		successMessage: isDelete
			? "User successfully removed from Product"
			: "User successfully added to Product",
	});
};
